import React from 'react';
import * as Styles from './TrialTimeline.styles';

const TrialTimeline = ({ timelineItemsList }) => {
  const timelineBarHeight = (timelineItemsList.length * 90) - 10;

  return (
    <Styles.TimeLineContainer>
      <Styles.TimeLineBar height={timelineBarHeight} />

      {timelineItemsList.map(item => (
        <Styles.TimeLineItem key={item.testId}>
          {item.variant === 'gradientBlue' && (
            <Styles.TimeLineIcon>
              {item.icon}
            </Styles.TimeLineIcon>
          )}

          {item.variant === 'white' && (
            <Styles.WhiteTimeLineIcon>
              {item.icon}
            </Styles.WhiteTimeLineIcon>
          )}

          <Styles.TimeLineItemContent>
            <Styles.TimeLineItemTitle>{item.title}</Styles.TimeLineItemTitle>
            <Styles.TimeLineItemDescription>{item.description}</Styles.TimeLineItemDescription>
          </Styles.TimeLineItemContent>
        </Styles.TimeLineItem>
      ))}
    </Styles.TimeLineContainer>
  );
};

export default TrialTimeline;
